import { connect } from 'react-redux'
import {
  getConfig,
  isConfigLoaded,
  isConfigLoading,
  isConfigFailed
} from './selectors'

const mapConfigState = state => ({
  config: getConfig(state),
  isConfigLoaded: isConfigLoaded(state),
  isConfigLoading: isConfigLoading(state),
  isConfigFailed: isConfigFailed(state)
})

export default connect(mapConfigState)



// WEBPACK FOOTER //
// ./src/modules/config/withConfig.js